import React, { useCallback, useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { ExclamationCircleOutlined, PauseCircleOutlined, PlayCircleOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { GripVertical } from 'lucide-react';
import Colors from '../../common/color';
import Fontsizes from "../../common/fontSize";
import FontWeights from "../../common/fontWeight";

interface ExamProps {
    type: string;
}

const Exam: React.FC<ExamProps> = ({ type }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const examQuestionSkillQuestions = location?.state?.examQuestionSkill?.ExamQuestionSkillQuestions;
    const skill = location?.state?.examQuestionSkill?.Skill;

    // useEffect(() => {
    // const disableRightClick = (e) => {
    //     e.preventDefault();
    // };

    // // Disable right-click for the whole page
    // document.addEventListener("contextmenu", disableRightClick);

    // const disableCopyCutPaste = (e) => {
    //     e.preventDefault();
    // };

    // document.addEventListener("copy", disableCopyCutPaste);
    // document.addEventListener("cut", disableCopyCutPaste);
    // document.addEventListener("paste", disableCopyCutPaste);

    // return () => {
    //     document.removeEventListener("contextmenu", disableRightClick);
    //     document.removeEventListener("copy", disableCopyCutPaste);
    //     document.removeEventListener("cut", disableCopyCutPaste);
    //     document.removeEventListener("paste", disableCopyCutPaste);
    // };
    // }, []);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isInstructions, setIsInstructions] = useState(true);

    const [selectedAnswers, setSelectedAnswers] = useState(() => {
        const initialAnswers = new Array(examQuestionSkillQuestions?.length).fill(null);
        examQuestionSkillQuestions?.forEach((question, index) => {
            if (question?.Question?.QuestionSkill?.TypeQuestion?.name === 'Listening1617') {
                initialAnswers[index] = {};
            }
        });
        return initialAnswers;
    });
    const [answeredQuestions, setAnsweredQuestions] = useState(
        new Array(examQuestionSkillQuestions?.length).fill(false)
    );

    // Timer configuration
    const initialTime = skill?.timeAllow * 60 + 5; // 5 minutes 45 seconds
    const [timeLeft, setTimeLeft] = useState(initialTime);
    const [isWarning, setIsWarning] = useState(false);
    const [isExamStarted, setIsExamStarted] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [availableSentences, setAvailableSentences] = useState([]);
    const [dragDropStates, setDragDropStates] = useState({});
    const [orderedSentences, setOrderedSentences] = useState(Array(5).fill(null));
    const [answers, setAnswers] = useState({});

    let audioList = [];
    if (skill?.name === "Listening") {
        examQuestionSkillQuestions?.forEach(examQuestionSkillQuestion => {
            if (examQuestionSkillQuestion?.Question?.linkAudio) {
                audioList.push({
                    questionId: examQuestionSkillQuestion?.Question?.id,
                    url: examQuestionSkillQuestion?.Question?.linkAudio
                });
            }
        })
    }

    const [audioStates, setAudioStates] = useState(
        audioList.reduce((acc, audio) => ({
            ...acc,
            [audio.questionId]: {
                isPlaying: false,
                playCount: 0,
                audioElement: new Audio(audio.url)
            }
        }), {})
    );

    const [showTranscript, setShowTranscript] = useState(false);
    const [showTranslations,] = useState(false);
    const [isTranslating,] = useState(false);
    const [translatedQuestions,] = useState(null);

    const handleToggle = (audioId) => {
        const currentState = audioStates[audioId];

        // Stop all other playing audios first
        Object.keys(audioStates).forEach(id => {
            if (id !== audioId.toString() && audioStates[id].isPlaying) {
                audioStates[id].audioElement.pause();
                setAudioStates(prev => ({
                    ...prev,
                    [id]: {
                        ...prev[id],
                        isPlaying: false
                    }
                }));
            }
        });

        // If audio is currently playing, stop it
        if (currentState.isPlaying) {
            currentState.audioElement.pause();
            // If this was the last play, increment count after stopping
            if (currentState.playCount === 2) {
                setAudioStates(prev => ({
                    ...prev,
                    [audioId]: {
                        ...prev[audioId],
                        isPlaying: false,
                        playCount: prev[audioId].playCount + 1
                    }
                }));
            } else {
                setAudioStates(prev => ({
                    ...prev,
                    [audioId]: {
                        ...prev[audioId],
                        isPlaying: false
                    }
                }));
            }
            return;
        }

        // Check if maximum plays reached
        if (currentState.playCount >= 3) {
            return;
        }

        // Start playing and count as one play
        currentState.audioElement.currentTime = 0;
        currentState.audioElement.play();

        setAudioStates(prev => ({
            ...prev,
            [audioId]: {
                ...prev[audioId],
                isPlaying: true,
                playCount: prev[audioId].playCount + 1
            }
        }));

        // Add ended event listener to handle completion
        currentState.audioElement.onended = () => {
            // If this was the last play, increment count after completion
            if (currentState.playCount === 2) {
                setAudioStates(prev => ({
                    ...prev,
                    [audioId]: {
                        ...prev[audioId],
                        isPlaying: false,
                        playCount: prev[audioId].playCount + 1
                    }
                }));
            } else {
                setAudioStates(prev => ({
                    ...prev,
                    [audioId]: {
                        ...prev[audioId],
                        isPlaying: false
                    }
                }));
            }
        };
    };

    useEffect(() => {
        const initialStates = {};
        examQuestionSkillQuestions?.forEach(examQuestionSkillQuestion => {
            if (examQuestionSkillQuestion?.Question?.QuestionSkill?.TypeQuestion?.name === "Reading23") {
                const sentences = examQuestionSkillQuestion?.Question?.SubQuestions?.map(
                    subQuestion => subQuestion?.Answers[0]?.content
                ) || [];

                // Chỉ khởi tạo nếu chưa có state cho câu hỏi này
                if (!dragDropStates[examQuestionSkillQuestion?.Question?.id]) {
                    initialStates[examQuestionSkillQuestion?.Question?.id] = {
                        availableSentences: sentences,
                        orderedSentences: Array(5).fill(null)
                    };
                }
            }
        });

        // Merge state mới với state hiện tại
        setDragDropStates(prev => ({
            ...prev,
            ...initialStates
        }));
        // eslint-disable-next-line
    }, [examQuestionSkillQuestions]);

    useEffect(() => {
        const currentQuestion = examQuestionSkillQuestions[currentQuestionIndex];
        if (currentQuestion?.Question?.QuestionSkill?.TypeQuestion?.name === "Reading23") {
            const state = dragDropStates[currentQuestion?.Question?.id];
            if (state) {
                setAvailableSentences([...state.availableSentences]);
                setOrderedSentences([...state.orderedSentences]);
            }
        }
    }, [currentQuestionIndex, dragDropStates, examQuestionSkillQuestions]);

    const updateQuestionState = (questionId, newAvailable, newOrdered) => {
        setDragDropStates(prev => ({
            ...prev,
            [questionId]: {
                availableSentences: newAvailable,
                orderedSentences: newOrdered
            }
        }));
    };

    const handleDragStart = (e, sentence, fromColumn) => {
        // Disable drag when translating
        if (isTranslating) {
            e.preventDefault();
            return;
        }

        e.dataTransfer.setData('text/plain', JSON.stringify({
            sentence,
            fromColumn
        }));
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (e, index, targetColumn) => {
        e.preventDefault();

        // Disable drop when translating
        if (isTranslating) {
            return;
        }

        const data = JSON.parse(e.dataTransfer.getData('text/plain'));
        const { sentence, fromColumn } = data;
        const currentQuestion = examQuestionSkillQuestions[currentQuestionIndex];
        const currentQuestionId = currentQuestion?.Question?.id;

        if (fromColumn === 'right' && targetColumn === 'left') {
            // Kéo từ phải sang trái
            if (orderedSentences[index] === null) {
                const newAvailable = availableSentences.filter(s => s !== sentence);
                const newOrdered = [...orderedSentences];
                newOrdered[index] = sentence;

                // Cập nhật cả local state và global state
                setAvailableSentences(newAvailable);
                setOrderedSentences(newOrdered);
                updateQuestionState(currentQuestionId, newAvailable, newOrdered);

                // Đánh dấu câu hỏi đã được trả lời khi có ít nhất một câu được kéo sang trái
                setAnsweredQuestions(prev => {
                    const newAnswered = [...prev];
                    newAnswered[currentQuestionIndex] = true;
                    return newAnswered;
                });
            }
        } else if (fromColumn === 'left' && targetColumn === 'right') {
            // Kéo từ trái sang phải
            const sentenceToMove = orderedSentences[index];
            if (sentenceToMove) {
                const newOrdered = [...orderedSentences];
                newOrdered[index] = null;
                const newAvailable = [...availableSentences, sentenceToMove];

                setOrderedSentences(newOrdered);
                setAvailableSentences(newAvailable);
                updateQuestionState(currentQuestionId, newAvailable, newOrdered);

                // Kiểm tra xem còn câu nào ở cột trái không
                const hasRemainingAnswers = newOrdered.some(item => item !== null);
                setAnsweredQuestions(prev => {
                    const newAnswered = [...prev];
                    newAnswered[currentQuestionIndex] = hasRemainingAnswers;
                    return newAnswered;
                });
            }
        } else if (fromColumn === 'left' && targetColumn === 'left') {
            // Sắp xếp lại trong cột trái
            const draggedIndex = orderedSentences.indexOf(sentence);
            if (draggedIndex !== -1 && draggedIndex !== index) {
                const newOrdered = [...orderedSentences];
                [newOrdered[draggedIndex], newOrdered[index]] =
                    [newOrdered[index], newOrdered[draggedIndex]];

                setOrderedSentences(newOrdered);
                updateQuestionState(currentQuestionId, availableSentences, newOrdered);
            }
        }
    };

    // Add new state for scores
    const [scores, setScores] = useState({});
    const [totalScore, setTotalScore] = useState(0);

    // Add scoring function
    const calculateScore = useCallback((questionType, userAnswers, question) => {
        switch (questionType) {
            case 'Reading1':
                let correctCountReading1 = 0;
                question.SubQuestions.forEach(subQuestion => {
                    const userAnswer = userAnswers[subQuestion.id];
                    const correctAnswer = subQuestion.Answers.find(answer => answer.isCorrect === '1')?.id;
                    if (userAnswer === correctAnswer.toString()) {
                        correctCountReading1 += subQuestion.point;
                    }
                });
                return {
                    score: correctCountReading1,
                };
            case 'Reading23':
                let correctCountReading23 = 0;
                const orderedState = dragDropStates[question.id]?.orderedSentences || [];

                // Get the correct answers sorted by correctPosition
                const correctAnswers = question.SubQuestions
                    .slice()
                    .sort((a, b) => a.Answers[0].correctPosition - b.Answers[0].correctPosition)
                    .map(sq => sq.Answers[0].content);

                // Compare each position
                for (let i = 0; i < correctAnswers.length; i++) {
                    // If we're in translated mode, we need to map back to original content for comparison
                    let userAnswer = orderedState[i];

                    if (showTranslations && translatedQuestions) {
                        // Find the translated question
                        const translatedQuestion = translatedQuestions.find(q => q.Question.id === question.id);
                        if (translatedQuestion) {
                            // Find the index of the translated sentence
                            const translatedSentences = translatedQuestion.Question.SubQuestions.map(
                                sq => sq.Answers[0].content
                            );
                            const index = translatedSentences.findIndex(s => s === userAnswer);

                            // If found, get the corresponding original sentence
                            if (index !== -1) {
                                const originalSentences = question.SubQuestions.map(
                                    sq => sq.Answers[0].content
                                );
                                userAnswer = originalSentences[index];
                            }
                        }
                    }

                    // Check if the answer is correct
                    if (userAnswer === correctAnswers[i]) {
                        correctCountReading23 += question.SubQuestions[i].point;
                    } else {
                        // Stop counting points after the first incorrect answer
                        break;
                    }
                }

                return {
                    score: correctCountReading23,
                };
            case 'Reading4':
                // let correctCountReading4 = 0;
                // const answerFrequency = {};
                // const correctAnswersForReading4 = {};

                // First, get all correct answers and their frequencies
                // question.SubQuestions.forEach(subQuestion => {
                //     const correctAnswer = subQuestion.Answers.find(answer => answer.isCorrect === '1');
                //     if (correctAnswer) {
                //         correctAnswersForReading4[subQuestion.id] = correctAnswer.id;
                //         // answerFrequency[correctAnswer.id] = (answerFrequency[correctAnswer.id] || 0) + 1;
                //         if (userAnswer === correctAnswer?.toString()) {
                //             correctCountReading5 += subQuestion.point;
                //         }
                //     }
                // });

                // Calculate points for each answer
                // question.SubQuestions.forEach(subQuestion => {
                //     const userAnswer = userAnswers[subQuestion.id];
                //     const correctAnswer = correctAnswersForReading4[subQuestion.id];

                //     if (userAnswer === correctAnswer?.toString()) {
                //         // If this answer appears twice, each correct instance is worth 2 points
                //         // If it appears once, it's worth 4 points
                //         const frequency = answerFrequency[correctAnswer];
                //         correctCountReading4 += (frequency === 1) ? 4 : 2;
                //     }
                // });

                let correctCountReading4 = 0;
                question.SubQuestions.forEach(subQuestion => {
                    const userAnswer = userAnswers[subQuestion.id];
                    const correctAnswer = subQuestion.Answers.find(answer => answer.isCorrect === '1')?.id;
                    if (userAnswer === correctAnswer?.toString()) {
                        correctCountReading4 += subQuestion.point;
                    }
                });

                return { score: correctCountReading4 };
            case 'Reading5':
                let correctCountReading5 = 0;
                question.SubQuestions.forEach(subQuestion => {
                    const userAnswer = userAnswers[subQuestion.id];
                    const correctAnswer = subQuestion.Answers.find(answer => answer.isCorrect === '1')?.id;
                    if (userAnswer === correctAnswer?.toString()) {
                        correctCountReading5 += subQuestion.point;
                    }
                });
                return { score: correctCountReading5 };
            case 'Listening1To13':
                let correctCountListening = 0;
                const questionIndexListening1To13 = examQuestionSkillQuestions.findIndex(q => q.Question?.id === question.id);
                const userSelectedAnswerListening1To13 = selectedAnswers[questionIndexListening1To13];

                if (userSelectedAnswerListening1To13) {
                    const correctAnswer = question.SubQuestions[0]?.Answers.find(answer => answer.isCorrect === '1');
                    if (userSelectedAnswerListening1To13.id === correctAnswer?.id) {
                        correctCountListening += question.SubQuestions[0]?.point || 0;
                    }
                }
                return {
                    score: correctCountListening,
                };
            case 'Listening14':
                let correctCountListening14 = 0;
                question.SubQuestions.forEach(subQuestion => {
                    const selectedAnswer = answers[subQuestion.id];
                    const correctAnswer = subQuestion.Answers.find(answer => answer.isCorrect === '1')?.id;
                    if (selectedAnswer === correctAnswer?.toString()) {
                        correctCountListening14 += subQuestion.point;
                    }
                });
                return { score: correctCountListening14 };
            case 'Listening15':
                let correctCountListening15 = 0;
                question.SubQuestions.forEach(subQuestion => {
                    const selectedAnswer = answers[subQuestion.id];
                    const correctAnswer = subQuestion.Answers.find(answer => answer.isCorrect === '1')?.id;
                    if (selectedAnswer === correctAnswer?.toString()) {
                        correctCountListening15 += subQuestion.point;
                    }
                });
                return { score: correctCountListening15 };
            case 'Listening1617':
                let correctCountListening1617 = 0;
                const questionIndex = examQuestionSkillQuestions.findIndex(q => q.Question?.id === question.id);
                const userSelectedAnswers = selectedAnswers[questionIndex];

                if (userSelectedAnswers) {
                    question.SubQuestions.forEach(subQuestion => {
                        const selectedAnswer = userSelectedAnswers[subQuestion.id];
                        const correctAnswer = subQuestion.Answers.find(answer => answer.isCorrect === '1');
                        if (selectedAnswer?.id === correctAnswer?.id) {
                            correctCountListening1617 += subQuestion.point;
                        }
                    });
                }
                return { score: correctCountListening1617 };
            default:
                return { score: 0 };
        }
    }, [dragDropStates, selectedAnswers, examQuestionSkillQuestions, answers, showTranslations, translatedQuestions]);

    // Modify handleSubmitExam to calculate scores
    const handleSubmitExam = useCallback(() => {
        if (isSubmitted) return;
        Modal.confirm({
            title: "Are you sure you want to submit the exam?",
            content: "Once submitted, you will not be able to change your answers.",
            okText: "Submit",
            okButtonProps: { style: { backgroundColor: Colors.primary }, size: 'large' },
            cancelButtonProps: { size: 'large' },
            icon: <ExclamationCircleOutlined style={{ color: Colors.primary }} />,
            onOk: () => {
                // Calculate scores for all questions
                const questionScores = {};
                let total = 0;
                examQuestionSkillQuestions.forEach((examQuestionSkillQuestion, index) => {
                    const questionType = examQuestionSkillQuestion?.Question?.QuestionSkill?.TypeQuestion?.name;
                    const score = calculateScore(
                        questionType,
                        answers,
                        examQuestionSkillQuestion?.Question
                    );
                    questionScores[examQuestionSkillQuestion?.Question?.id] = score;
                    total += score.score;
                });

                setScores(questionScores);
                setTotalScore(total);
                setIsSubmitted(true);
                setIsExamStarted(false);
                setCurrentQuestionIndex(0);
            },
        });
    }, [isSubmitted, examQuestionSkillQuestions, answers, calculateScore]);

    // Timer effect
    useEffect(() => {
        let timerId;

        // Only start timer when exam has begun and time is left
        if (isExamStarted && timeLeft > 0) {
            timerId = setInterval(() => {
                setTimeLeft((prevTime) => {
                    if (prevTime <= 1) {
                        // Calculate scores when time runs out
                        const questionScores = {};
                        let total = 0;
                        examQuestionSkillQuestions.forEach((examQuestionSkillQuestion) => {
                            const questionType = examQuestionSkillQuestion?.Question?.QuestionSkill?.TypeQuestion?.name;
                            const score = calculateScore(
                                questionType,
                                answers,
                                examQuestionSkillQuestion?.Question
                            );
                            questionScores[examQuestionSkillQuestion?.Question?.id] = score;
                            total += score.score;
                        });

                        // Update scores and exam state
                        setScores(questionScores);
                        setTotalScore(total);
                        setIsSubmitted(true);
                        setIsExamStarted(false);
                        setCurrentQuestionIndex(0);

                        // Show modal after scores are calculated
                        Modal.info({
                            title: "Your exam has finished",
                            content: "Time's up! Your exam has been automatically submitted.",
                            onOk: () => { },
                            okButtonProps: { style: { backgroundColor: Colors.primary }, size: 'large' },
                            icon: <ExclamationCircleOutlined style={{ color: Colors.primary }} />,
                        });

                        clearInterval(timerId);
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
        }

        // Cleanup interval on component unmount or when exam starts/stops
        return () => {
            if (timerId) clearInterval(timerId);
        };
    }, [isExamStarted, timeLeft, examQuestionSkillQuestions, answers, calculateScore]);

    // Warning effect
    useEffect(() => {
        if (timeLeft <= 5 * 60) {
            setIsWarning(true);
        }
    }, [timeLeft]);

    // Handle answer selection
    const handleAnswerSelect = (answer) => {
        if (!isInstructions && isExamStarted && !isSubmitted) {
            const currentQuestion = examQuestionSkillQuestions[currentQuestionIndex];
            const questionType = currentQuestion?.Question?.QuestionSkill?.TypeQuestion?.name;

            if (questionType === 'Listening1To13') {
                setSelectedAnswers(prev => {
                    const newAnswers = [...prev];
                    newAnswers[currentQuestionIndex] = answer;
                    return newAnswers;
                });

                // Đánh dấu câu hỏi đã được trả lời
                setAnsweredQuestions(prev => {
                    const newAnswered = [...prev];
                    newAnswered[currentQuestionIndex] = true;
                    return newAnswered;
                });

                // Cập nhật answers state
                setAnswers(prev => ({
                    ...prev,
                    [currentQuestion.Question.id]: answer.id
                }));
            } else if (questionType === 'Listening1617') {
                // Giữ nguyên logic cũ cho Listening1617
                const subQuestionId = answer.SubQuestionId;
                setSelectedAnswers(prev => {
                    const newAnswers = [...prev];
                    if (!newAnswers[currentQuestionIndex]) {
                        newAnswers[currentQuestionIndex] = {};
                    }
                    newAnswers[currentQuestionIndex] = {
                        ...newAnswers[currentQuestionIndex],
                        [subQuestionId]: answer
                    };
                    return newAnswers;
                });

                setAnsweredQuestions(prev => {
                    const newAnswered = [...prev];
                    newAnswered[currentQuestionIndex] = true;
                    return newAnswered;
                });
            } else {
                // Xử lý cho các loại câu hỏi khác
                setSelectedAnswers(prev => {
                    const newAnswers = [...prev];
                    newAnswers[currentQuestionIndex] = answer;
                    return newAnswers;
                });

                setAnsweredQuestions(prev => {
                    const newAnswered = [...prev];
                    newAnswered[currentQuestionIndex] = true;
                    return newAnswered;
                });
            }
        }
    };

    // Navigation handlers
    const handleNext = () => {
        if (isInstructions) {
            // Start exam and timer
            setIsInstructions(false);
            if (!isSubmitted) {
                setIsExamStarted(true);
            }
        } else if (currentQuestionIndex < examQuestionSkillQuestions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
    };

    const handlePrevious = () => {
        if (isInstructions) {
            // Stay on instructions page
        } else if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        } else {
            setIsInstructions(true);
        }
    };

    // Modal handlers
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleCancel = () => setIsModalOpen(false);

    const handleQuestionSelect = (questionIndex) => {
        if (isExamStarted || isSubmitted) {
            setCurrentQuestionIndex(questionIndex);
            setIsInstructions(false);
        }
    };

    const handleRetakeExam = () => {
        // Reset basic exam state
        setIsInstructions(true);
        setCurrentQuestionIndex(0);
        setTimeLeft(initialTime);
        setIsWarning(false);
        setIsSubmitted(false);
        setIsExamStarted(false);
        setIsModalOpen(false);

        // Clear all answers
        setSelectedAnswers(() => {
            const initialAnswers = new Array(examQuestionSkillQuestions?.length).fill(null);
            examQuestionSkillQuestions?.forEach((examQuestionSkillQuestion, index) => {
                if (examQuestionSkillQuestion?.Question?.QuestionSkill?.TypeQuestion?.name === 'Listening1617') {
                    initialAnswers[index] = {};
                }
            });
            return initialAnswers;
        });
        setAnsweredQuestions(new Array(examQuestionSkillQuestions?.length).fill(false));
        setAnswers({});
        setScores({});
        setTotalScore(0);

        // Reset drag-drop states for Reading23
        const initialDragDropStates = {};
        examQuestionSkillQuestions?.forEach(examQuestionSkillQuestion => {
            if (examQuestionSkillQuestion?.Question?.QuestionSkill?.TypeQuestion?.name === "Reading23") {
                const sentences = examQuestionSkillQuestion?.Question?.SubQuestions?.map(
                    subQuestion => subQuestion?.Answers[0]?.content
                ) || [];
                initialDragDropStates[examQuestionSkillQuestion?.Question?.id] = {
                    availableSentences: sentences,
                    orderedSentences: Array(5).fill(null)
                };
            }
        });
        setDragDropStates(initialDragDropStates);
        setAvailableSentences([]);
        setOrderedSentences(Array(5).fill(null));

        // Reset audio states for Listening questions
        if (skill?.name === "Listening") {
            const initialAudioStates = audioList.reduce((acc, audio) => ({
                ...acc,
                [audio.questionId]: {
                    isPlaying: false,
                    playCount: 0,
                    audioElement: new Audio(audio.url)
                }
            }), {});
            setAudioStates(initialAudioStates);
        }

        setShowKeyQuestions({});
    };

    const formatTime = (time) => {
        const hours = String(Math.floor(time / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((time % 3600) / 60)).padStart(2, "0");
        const seconds = String(time % 60).padStart(2, "0");
        return `${hours}:${minutes}:${seconds}`;
    };
    const progressPercent = ((initialTime - timeLeft) / initialTime) * 100;

    // Cập nhật câu trả lời khi chọn trong dropdown
    const handleAnswerChange = (subQuestionId, value) => {
        setAnswers((prev) => ({
            ...prev,
            [subQuestionId]: value,
        }));
    };

    // Tách và thay thế `[1]`, `[2]`, ... bằng combo box
    const renderContent = (content, subQuestions) => {
        const subQuestionsMap = subQuestions.reduce((map, subQuestion) => {
            map[subQuestion.title] = subQuestion;
            return map;
        }, {});

        if (!content) return null;

        // Tách nội dung thành các dòng và giữ nguyên khoảng trống
        const lines = content.split('\n');

        return (
            <div style={{ whiteSpace: 'pre-line' }}>
                {lines.map((line, lineIndex) => {
                    const parts = line.split(/(\[\d+\])/);
                    return (
                        <div key={lineIndex} style={{ marginBottom: line.trim() === '' ? '1em' : '0' }}>
                            {parts.map((part, partIndex) => {
                                const match = part.match(/\[(\d+)\]/);
                                if (match) {
                                    const subQuestionTitle = match[0];
                                    const subQuestion = subQuestionsMap[subQuestionTitle];
                                    if (subQuestion) {
                                        return (
                                            <select
                                                key={partIndex}
                                                value={answers[subQuestion.id] || ""}
                                                onChange={(e) => {
                                                    handleAnswerChange(subQuestion.id, e.target.value)
                                                    handleAnswerSelect(subQuestion.id)
                                                }}
                                                className="border rounded px-2 py-1 mx-1"
                                                disabled={isSubmitted}
                                            >
                                                <option value=""></option>
                                                {subQuestion?.Answers?.map((answer) => (
                                                    <option key={answer?.id} value={answer?.id}>
                                                        {answer?.content}
                                                    </option>
                                                ))}
                                            </select>
                                        );
                                    }
                                }
                                return part;
                            })}
                        </div>
                    );
                })}
            </div>
        );
    };

    // Add translation function using Google Translate API
    // const translateText = async (text, targetLang = 'vi') => {
    //     try {
    //         const lines = text.split('\n');
    //         const translatedLines = await Promise.all(
    //             lines.map(async (line) => {
    //                 if (line.trim() === '') return '';

    //                 const parts = line.split(/(\[\d+\])/);
    //                 const translatedParts = await Promise.all(
    //                     parts.map(async (part) => {
    //                         if (part.match(/\[\d+\]/)) {
    //                             return part;
    //                         }
    //                         if (part.trim()) {
    //                             const response = await fetch(`https://translation.googleapis.com/language/translate/v2?key=${process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY}`, {
    //                                 method: 'POST',
    //                                 headers: {
    //                                     'Content-Type': 'application/json',
    //                                 },
    //                                 body: JSON.stringify({
    //                                     q: part,
    //                                     target: targetLang,
    //                                 }),
    //                             });
    //                             const data = await response.json();
    //                             return data.data.translations[0].translatedText;
    //                         }
    //                         return part;
    //                     })
    //                 );
    //                 return translatedParts.join('');
    //             })
    //         );
    //         return translatedLines.join('\n');
    //     } catch (error) {
    //         console.error('Translation error:', error);
    //         return text;
    //     }
    // };

    // Sửa lại hàm translateExamContent
    // const translateExamContent = async () => {
    //     setIsTranslating(true);
    //     try {
    //         if (showTranslations) {
    //             // If showing translations, switch back to original content
    //             setShowTranslations(false);
    //             setTranslatedQuestions(null);

    //             // Reset dragDropStates về nội dung gốc nhưng giữ nguyên vị trí các câu đã sắp xếp
    //             const originalStates = {};
    //             examQuestionSkillQuestions.forEach(examQuestionSkillQuestion => {
    //                 if (examQuestionSkillQuestion?.Question?.QuestionSkill?.TypeQuestion?.name === "Reading23") {
    //                     // Lấy tất cả các câu gốc
    //                     const allOriginalSentences = examQuestionSkillQuestion?.Question?.SubQuestions?.map(
    //                         subQuestion => subQuestion?.Answers[0]?.content
    //                     ) || [];

    //                     // Lấy vị trí hiện tại của các câu đã sắp xếp trong bản dịch
    //                     const currentState = dragDropStates[examQuestionSkillQuestion?.Question?.id];
    //                     const currentTranslatedOrdered = currentState?.orderedSentences || Array(5).fill(null);

    //                     // Chuyển đổi các câu đã sắp xếp từ bản dịch sang bản gốc
    //                     const originalOrdered = currentTranslatedOrdered.map(translatedSentence => {
    //                         if (!translatedSentence) return null;

    //                         // Tìm vị trí của câu đã dịch trong danh sách câu đã dịch
    //                         const translatedQuestion = translatedQuestions.find(
    //                             q => q.Question.id === examQuestionSkillQuestion.Question.id
    //                         );
    //                         const translatedSentences = translatedQuestion?.Question?.SubQuestions?.map(
    //                             sq => sq?.Answers[0]?.content
    //                         ) || [];

    //                         const index = translatedSentences.findIndex(s => s === translatedSentence);
    //                         // Nếu tìm thấy, trả về câu gốc tương ứng
    //                         return index !== -1 ? allOriginalSentences[index] : null;
    //                     });

    //                     // Tính toán các câu còn lại trong available
    //                     const remainingAvailable = allOriginalSentences.filter(sentence => 
    //                         !originalOrdered.includes(sentence)
    //                     );

    //                     originalStates[examQuestionSkillQuestion?.Question?.id] = {
    //                         availableSentences: remainingAvailable,
    //                         orderedSentences: originalOrdered
    //                     };
    //                 }
    //             });

    //             setDragDropStates(originalStates);

    //             // Cập nhật state cho câu hỏi hiện tại
    //             const currentQuestion = examQuestionSkillQuestions[currentQuestionIndex];
    //             if (currentQuestion?.Question?.QuestionSkill?.TypeQuestion?.name === "Reading23") {
    //                 const state = originalStates[currentQuestion?.Question?.id];
    //                 if (state) {
    //                     setAvailableSentences([...state.availableSentences]);
    //                     setOrderedSentences([...state.orderedSentences]);
    //                 }
    //             }

    //         } else {
    //             // If showing original, translate content
    //             const translatedData = JSON.parse(JSON.stringify(examQuestionSkillQuestions)); // Deep copy

    //             for (const question of translatedData) {
    //                 // Translate title and content of main question
    //                 if (question.Question.title) {
    //                     question.Question.title = await translateText(question.Question.title);
    //                 }
    //                 if (question.Question.content) {
    //                     question.Question.content = await translateText(question.Question.content);
    //                 }

    //                 // Translate sub-questions and answers
    //                 if (question.Question.SubQuestions) {
    //                     for (const subQuestion of question.Question.SubQuestions) {
    //                         if (subQuestion.title && !subQuestion.title.match(/^\[\d+\]$/)) {
    //                             subQuestion.title = await translateText(subQuestion.title);
    //                         }

    //                         // Translate answers
    //                         if (subQuestion.Answers) {
    //                             for (const answer of subQuestion.Answers) {
    //                                 if (answer.content) {
    //                                     answer.content = await translateText(answer.content);
    //                                 }
    //                             }
    //                         }
    //                     }
    //                 }
    //             }

    //             // Cập nhật dragDropStates với nội dung đã dịch nhưng giữ nguyên vị trí các câu đã sắp xếp
    //             const translatedStates = {};
    //             translatedData.forEach(examQuestionSkillQuestion => {
    //                 if (examQuestionSkillQuestion?.Question?.QuestionSkill?.TypeQuestion?.name === "Reading23") {
    //                     // Lấy tất cả các câu đã dịch
    //                     const allTranslatedSentences = examQuestionSkillQuestion?.Question?.SubQuestions?.map(
    //                         subQuestion => subQuestion?.Answers[0]?.content
    //                     ) || [];

    //                     // Lấy vị trí hiện tại của các câu đã sắp xếp trong bản gốc
    //                     const currentState = dragDropStates[examQuestionSkillQuestion?.Question?.id];
    //                     const currentOriginalOrdered = currentState?.orderedSentences || Array(5).fill(null);

    //                     // Chuyển đổi các câu đã sắp xếp từ bản gốc sang bản dịch
    //                     const translatedOrdered = currentOriginalOrdered.map(originalSentence => {
    //                         if (!originalSentence) return null;

    //                         // Tìm vị trí của câu gốc trong danh sách câu gốc
    //                         const originalQuestion = examQuestionSkillQuestions.find(
    //                             q => q.Question.id === examQuestionSkillQuestion.Question.id
    //                         );
    //                         const originalSentences = originalQuestion?.Question?.SubQuestions?.map(
    //                             sq => sq?.Answers[0]?.content
    //                         ) || [];

    //                         const index = originalSentences.findIndex(s => s === originalSentence);
    //                         // Nếu tìm thấy, trả về câu đã dịch tương ứng
    //                         return index !== -1 ? allTranslatedSentences[index] : null;
    //                     });

    //                     // Tính toán các câu còn lại trong available
    //                     const remainingAvailable = allTranslatedSentences.filter(sentence => 
    //                         !translatedOrdered.includes(sentence)
    //                     );

    //                     translatedStates[examQuestionSkillQuestion?.Question?.id] = {
    //                         availableSentences: remainingAvailable,
    //                         orderedSentences: translatedOrdered
    //                     };
    //                 }
    //             });

    //             setDragDropStates(translatedStates);

    //             // Cập nhật state cho câu hỏi hiện tại
    //             const currentQuestion = translatedData[currentQuestionIndex];
    //             if (currentQuestion?.Question?.QuestionSkill?.TypeQuestion?.name === "Reading23") {
    //                 const state = translatedStates[currentQuestion?.Question?.id];
    //                 if (state) {
    //                     setAvailableSentences([...state.availableSentences]);
    //                     setOrderedSentences([...state.orderedSentences]);
    //                 }
    //             }

    //             setTranslatedQuestions(translatedData);
    //             setShowTranslations(true);
    //         }
    //     } catch (error) {
    //         console.error('Translation error:', error);
    //     } finally {
    //         setIsTranslating(false);
    //     }
    // };

    // Sửa lại nút dịch
    // const renderTranslationButton = () => (
    //     <Button
    //         icon={<TranslationOutlined spin={isTranslating} />}
    //         onClick={translateExamContent}
    //         disabled={(!isExamStarted && !isSubmitted) || isTranslating}
    //         size={window.innerWidth < 768 ? "middle" : "large"}
    //     >
    //         {
    //             isTranslating && window.innerWidth <= 425 ? '' :
    //                 isTranslating && window.innerWidth > 425 ? 'Translating...' :
    //                     showTranslations && window.innerWidth <= 425 ? '' :
    //                         showTranslations && window.innerWidth > 425 ? 'Show Original' :
    //                             window.innerWidth <= 425 ? '' : 'Click to Translate'
    //         }
    //     </Button>
    // );

    // Trong phần render, sử dụng translatedQuestions nếu có
    const questionsToRender = showTranslations && translatedQuestions ? translatedQuestions : examQuestionSkillQuestions;

    // Add isShowKey state for each question
    const [showKeyQuestions, setShowKeyQuestions] = useState({});

    // Update the handleShowKey function
    const handleShowKey = (questionId) => {
        setShowKeyQuestions(prev => ({
            ...prev,
            [questionId]: !prev[questionId]
        }));
    };

    return (
        <div
            className="min-h-screen bg-gray-50 flex flex-col items-center relative"
        // style={{
        //     userSelect: 'none',
        //     WebkitUserSelect: 'none',
        //     MozUserSelect: 'none',
        //     msUserSelect: 'none',
        // }}
        >
            <div
                className="absolute top-4 left-4 md:left-8 lg:left-12 cursor-pointer"
                onClick={() => {
                    Modal.confirm({
                        title: "Leave Exam",
                        content: "Are you sure you want to leave the exam? Your progress will be lost.",
                        okText: "Leave",
                        cancelText: "Stay",
                        okButtonProps: {
                            style: { backgroundColor: Colors.primary },
                            size: 'large'
                        },
                        cancelButtonProps: { size: 'large' },
                        onOk: () => {
                            navigate('/');  // Navigate to home page
                        },
                        icon: <ExclamationCircleOutlined style={{ color: Colors.primary }} />,
                    });
                }}
            >
                <span style={{
                    fontSize: window.innerWidth < 480 ? `${Fontsizes.md}` :
                        window.innerWidth < 768 ? `${Fontsizes.lg}` :
                            `${Fontsizes.xl}`,
                    fontWeight: `${FontWeights.bold}`,
                    color: Colors.primary
                }}>
                    HIEN LE APTIS
                </span>
            </div>

            {/* Timer Display - Made responsive */}
            <div className={`absolute top-4 right-4 md:right-8 lg:right-12 text-md ${isWarning ? 'text-orange-600' : 'text-black'}`}>
                {isExamStarted ? (
                    <div className="flex flex-col items-center justify-center w-full">
                        <div className={`text-2xl md:text-3xl lg:text-4xl font-bold ${isWarning ? 'text-orange-600' : 'text-black'}`}>
                            {formatTime(timeLeft)}
                        </div>
                        <div className="text-sm md:text-xl">Time remaining</div>
                        <div className="w-full max-w-[200px] md:max-w-[250px] mt-1">
                            <div className="w-full bg-gray-200 h-1">
                                <div
                                    className={`h-1 ${isWarning ? 'bg-orange-600' : 'bg-indigo-900'}`}
                                    style={{ width: `${progressPercent}%` }}
                                ></div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>

            {/* Exam Content - Made responsive */}
            <div className="p-2 md:p-4 w-full">
                <div className="p-3 md:p-6 w-full max-w-4xl mx-auto">
                    <h2 className="mb-2">
                        {
                            isInstructions && skill?.name === 'Reading' ? (
                                <div>
                                    <p className={`${window.innerWidth < 768 ? 'mt-16' : 'mb-4'}`} style={{
                                        fontSize: `${window.innerWidth < 768 ? Fontsizes.lg : Fontsizes.xxl}`, fontWeight: `${FontWeights.bold}`
                                    }}>
                                        Aptis General Reading Instructions
                                    </p>
                                    <div className="mb-4" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                        <p className="mb-2" style={{ fontWeight: `${FontWeights.bold}` }}>Reading</p>
                                        <p className="mb-2">The test has five parts.</p>
                                        <p className="mb-2">You have 35 minutes to complete the test.</p>
                                        <p className="mb-2">When you click on the 'Start' button, the test will be begin.</p>
                                    </div>
                                </div>
                            ) : isInstructions && skill?.name === 'Listening' && (
                                <div>
                                    <p className={`${window.innerWidth < 768 ? 'mt-16' : 'mb-4'}`} style={{
                                        fontSize: `${window.innerWidth < 768 ? Fontsizes.lg : Fontsizes.xxl}`, fontWeight: `${FontWeights.bold}`
                                    }}>
                                        Aptis General Listening Instructions
                                    </p>
                                    <div className="mb-4" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                        <p className="mb-2" style={{ fontWeight: `${FontWeights.bold}` }}>Listening</p>
                                        <p className="mb-2">You will listen to seventeen recordings.</p>
                                        <p className="mb-2">Click on the PLAY button to listen to each recording.</p>
                                        <p className="mb-2">You can listen to each recording TWO TIMES ONLY.</p>
                                        <p className="mb-2">You have 40 minutes to complete the test.</p>
                                        <p className="mb-2">When you click on the 'Start' button, the test will be begin.</p>
                                    </div>
                                </div>
                            )
                        }
                    </h2>
                    <div className="flex justify-between items-center mb-4 mt-6">
                        {
                            !isInstructions && (
                                <p style={{ fontSize: `${Fontsizes.xl}` }}>
                                    Question {questionsToRender[currentQuestionIndex]?.no} of {questionsToRender?.length}
                                    {isSubmitted && (
                                        <span style={{
                                            fontSize: `${Fontsizes.md}`,
                                            fontWeight: `${FontWeights.normal}`,
                                            color: 'red',
                                            marginLeft: '16px'
                                        }}>
                                            Point: {scores[questionsToRender[currentQuestionIndex]?.Question?.id]?.score}
                                        </span>
                                    )}
                                </p>
                            )}
                    </div>

                    <div className="mb-6">
                        {isInstructions ? (
                            <p style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>{

                            }</p>
                        ) : (
                            <>
                                {
                                    questionsToRender[currentQuestionIndex]?.Question?.QuestionSkill?.TypeQuestion?.name === 'Reading1' ? (
                                        <div>
                                            <div>
                                                {questionsToRender[currentQuestionIndex]?.Question?.title}
                                            </div>
                                            <pre className="font-sans mt-4" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                {renderContent(
                                                    questionsToRender[currentQuestionIndex]?.Question?.content,
                                                    questionsToRender[currentQuestionIndex]?.Question?.SubQuestions
                                                )}
                                            </pre>
                                            {isSubmitted && (
                                                <div className="mt-4">
                                                    {questionsToRender[currentQuestionIndex]?.Question?.SubQuestions?.map((subQuestion, index) => {
                                                        const userAnswer = answers[subQuestion.id];
                                                        const correctAnswer = subQuestion.Answers.find(answer => answer.isCorrect === '1');
                                                        const isCorrect = userAnswer === correctAnswer?.id?.toString();

                                                        return (
                                                            <div key={index} className="flex items-center mb-2">
                                                                <span className={`mr-2 ${isCorrect ? 'text-green-600' : 'text-red-600'}`}>
                                                                    {isCorrect ? '✓' : '✗'}
                                                                </span>
                                                                <span>{subQuestion.title}: {correctAnswer?.content}</span>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    ) : questionsToRender[currentQuestionIndex]?.Question?.QuestionSkill?.TypeQuestion?.name === 'Reading23' ? (
                                        <div>
                                            <div>
                                                {questionsToRender[currentQuestionIndex]?.Question?.title}
                                            </div>
                                            <div className="max-w-4xl mx-auto p-2 md:p-6">
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                                                    {/* Left Column - Ordered Sentences */}
                                                    <div className="border p-4 bg-gray-50">
                                                        <p className="mb-4" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                            {questionsToRender[currentQuestionIndex]?.Question?.content}
                                                        </p>
                                                        {orderedSentences.map((sentence, index) => (
                                                            <div
                                                                key={index}
                                                                className="mb-2"
                                                                onDragOver={!isSubmitted && !isTranslating ? handleDragOver : undefined}
                                                                onDrop={!isSubmitted && !isTranslating ? (e) => handleDrop(e, index, 'left') : undefined}
                                                                draggable={!isSubmitted && !isTranslating && sentence !== null}
                                                            >
                                                                <div className={`flex items-center gap-2 p-3 border ${sentence ? 'bg-white' : 'bg-gray-100 border-dashed'}`}>
                                                                    {sentence ? (
                                                                        <div
                                                                            className={`flex-1 ${!isSubmitted && !isTranslating ? 'cursor-move' : 'cursor-default'}`}
                                                                            draggable={!isSubmitted && !isTranslating}
                                                                            onDragStart={!isSubmitted && !isTranslating ? (e) => handleDragStart(e, sentence, 'left') : undefined}
                                                                        >
                                                                            <div className="flex items-center gap-2">
                                                                                {!isSubmitted && !isTranslating && <GripVertical className="text-gray-400" size={16} />}
                                                                                <span style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                                    {sentence}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="p-2"></div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {/* Right Column - Available Sentences */}
                                                    <div className="border p-4">
                                                        <div className="grid gap-4">
                                                            {availableSentences.map((sentence, index) => (
                                                                <div
                                                                    key={index}
                                                                    className={`p-4 border bg-white ${!isSubmitted && !isTranslating ? 'cursor-move' : 'cursor-default'}`}
                                                                    onDragStart={!isSubmitted && !isTranslating ? (e) => handleDragStart(e, sentence, 'right') : undefined}
                                                                    onDragOver={!isSubmitted && !isTranslating ? handleDragOver : undefined}
                                                                    onDrop={!isSubmitted && !isTranslating ? (e) => handleDrop(e, index, 'right') : undefined}
                                                                    draggable={!isSubmitted && !isTranslating}
                                                                >
                                                                    <div className="flex items-center gap-2">
                                                                        {!isSubmitted && !isTranslating && <GripVertical className="text-gray-400" size={16} />}
                                                                        <span style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                            {sentence}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                isSubmitted && (
                                                    <>
                                                        <div className="mt-4 flex flex-row">
                                                            <div>
                                                                <p className="mb-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                    Your answer:
                                                                </p>
                                                                {orderedSentences.map((sentence, index) => {
                                                                    const correctAnswers = questionsToRender[currentQuestionIndex]?.Question?.SubQuestions
                                                                        .slice()
                                                                        .sort((a, b) => a.Answers[0].correctPosition - b.Answers[0].correctPosition)
                                                                        .map(sq => sq.Answers[0].content);
                                                                    const isCorrect = sentence === correctAnswers[index];

                                                                    return (
                                                                        <div key={index} className="mb-2 flex items-center">
                                                                            <span className={`mr-2 ${isCorrect ? 'text-green-600' : 'text-red-600'}`}>
                                                                                {isCorrect ? '✓' : '✗'}
                                                                            </span>
                                                                            <div style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                                {index + 1}. {sentence}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                            <div className="ml-10">
                                                                <p className="mb-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                    Correct answer:
                                                                </p>
                                                                {
                                                                    questionsToRender[currentQuestionIndex]?.Question?.SubQuestions
                                                                        ?.slice()
                                                                        .sort((a, b) => a.Answers[0]?.correctPosition - b.Answers[0]?.correctPosition)
                                                                        .map((subQuestion, index) => (
                                                                            <div
                                                                                key={index}
                                                                                className="mb-3"
                                                                            >
                                                                                <div style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                                    {subQuestion?.Answers[0]?.correctPosition}. {subQuestion?.Answers[0]?.content}
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                }
                                                            </div>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                    ) : questionsToRender[currentQuestionIndex]?.Question?.QuestionSkill?.TypeQuestion?.name === 'Reading4' ? (
                                        <div className="py-4">
                                            <div>
                                                {questionsToRender[currentQuestionIndex]?.Question?.title}
                                            </div>
                                            <div className="mt-4 grid grid-cols-1">
                                                {questionsToRender[currentQuestionIndex]?.Question?.content?.split('\n\n').map((paragraph, idx) => (
                                                    <div
                                                        key={idx}
                                                        className="mb-4"
                                                        style={{
                                                            fontSize: `${Fontsizes.sm}`,
                                                            fontWeight: `${FontWeights.normal}`,
                                                            whiteSpace: 'pre-wrap',
                                                            wordBreak: 'break-word'
                                                        }}
                                                    >
                                                        {paragraph.trim()}
                                                    </div>
                                                ))}
                                            </div>
                                            {questionsToRender[currentQuestionIndex]?.Question?.SubQuestions?.map((subQuestion, index) => (
                                                <div className="mb-4 mt-4" key={index}>
                                                    <div className="flex items-center">
                                                        <span className="font-sans mr-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                            <span className="font-bold">{index + 1}.</span> {subQuestion.title}
                                                        </span>
                                                        <select
                                                            value={answers[subQuestion.id] || ""}
                                                            onChange={(e) => {
                                                                handleAnswerChange(subQuestion.id, e.target.value);
                                                                handleAnswerSelect(subQuestion.id);
                                                            }}
                                                            className="border rounded px-2 py-1 mx-1"
                                                            disabled={isSubmitted}
                                                        >
                                                            <option value=""></option>
                                                            {subQuestion?.Answers?.map((answer) => (
                                                                <option key={answer.id} value={answer.id}>
                                                                    {answer.content}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {isSubmitted && (
                                                            <div className="flex items-center ml-4">
                                                                <span className={answers[subQuestion.id] === subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.id?.toString()
                                                                    ? 'text-green-600 mr-2'
                                                                    : 'text-red-600 mr-2'
                                                                }>
                                                                    {answers[subQuestion.id] === subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.id?.toString()
                                                                        ? '✓'
                                                                        : '✗'
                                                                    }
                                                                </span>
                                                                <span className="mr-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                    Correct answer:
                                                                </span>
                                                                <span className={`${answers[subQuestion.id] === subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.id?.toString()
                                                                    ? 'text-green-600'
                                                                    : 'text-red-600'
                                                                    }`}>
                                                                    {subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.content}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : questionsToRender[currentQuestionIndex]?.Question?.QuestionSkill?.TypeQuestion?.name === 'Reading5' ? (
                                        <div className="py-4">
                                            <div>
                                                {questionsToRender[currentQuestionIndex]?.Question?.title}
                                            </div>
                                            <pre className="font-sans mt-4" style={{ fontSize: `${Fontsizes.xxl}`, fontWeight: `${FontWeights.normal}` }}>
                                                {questionsToRender[currentQuestionIndex]?.Question?.content}
                                            </pre>
                                            {!isSubmitted && type === 'private' && (
                                                <button
                                                    onClick={() => handleShowKey(questionsToRender[currentQuestionIndex]?.Question?.id)}
                                                    className="mb-2 mt-4 border border-primary-500 text-primary-500 font-medium rounded-lg px-2 py-1 md:px-4 md:py-2 text-sm md:text-base"
                                                >
                                                    {showKeyQuestions[questionsToRender[currentQuestionIndex]?.Question?.id] ? 'Hide Key' : 'Show Key'}
                                                </button>
                                            )}
                                            <div className="overflow-x-auto">
                                                {questionsToRender[currentQuestionIndex]?.Question?.SubQuestions?.map((subQuestion, index) => (
                                                    <div className="mb-4 mt-4" key={index}>
                                                        <div className="flex items-center">
                                                            <span>{index + 1}.</span>
                                                            <select
                                                                value={answers[subQuestion.id] || ""}
                                                                onChange={(e) => {
                                                                    handleAnswerChange(subQuestion.id, e.target.value)
                                                                    handleAnswerSelect(subQuestion.id)
                                                                }}
                                                                className="border rounded px-2 py-1 mx-1"
                                                                disabled={isSubmitted}
                                                            >
                                                                <option value=""></option>
                                                                {subQuestion?.Answers?.map((answer) => (
                                                                    <option key={answer.id} value={answer.id}>
                                                                        {answer.content}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {(isSubmitted || showKeyQuestions[questionsToRender[currentQuestionIndex]?.Question?.id]) && (
                                                                <div className="flex items-center ml-4">
                                                                    <span className={answers[subQuestion.id] === subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.id?.toString()
                                                                        ? 'text-green-600 mr-2'
                                                                        : 'text-red-600 mr-2'
                                                                    }>
                                                                        {answers[subQuestion.id] === subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.id?.toString()
                                                                            ? '✓'
                                                                            : '✗'
                                                                        }
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {(isSubmitted || showKeyQuestions[questionsToRender[currentQuestionIndex]?.Question?.id]) && (
                                                            <div className="flex items-center ml-4 mt-2">
                                                                <span className="mr-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.bold}` }}>
                                                                    Correct answer:
                                                                </span>
                                                                <span className={`${answers[subQuestion.id] === subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.id?.toString()
                                                                    ? 'text-green-600'
                                                                    : 'text-red-600'
                                                                    }`}>
                                                                    {subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.content}
                                                                </span>
                                                            </div>
                                                        )}
                                                        {
                                                            subQuestion.title && <div className="mt-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                {index + 1}. {subQuestion.title}
                                                            </div>
                                                        }
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ) : questionsToRender[currentQuestionIndex]?.Question?.QuestionSkill?.TypeQuestion?.name === 'Listening1To13' ? (
                                        <div>
                                            <p className="mb-4" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                {questionsToRender[currentQuestionIndex]?.Question?.title}
                                            </p>
                                            {
                                                audioList?.map((audio, index) => (
                                                    audio?.questionId === questionsToRender[currentQuestionIndex]?.Question?.id) &&
                                                    <button
                                                        key={index}
                                                        onClick={() => handleToggle(audio?.questionId)}
                                                        disabled={audioStates[audio?.questionId].playCount >= 3}
                                                        className={`flex items-center ${audioStates[audio?.questionId].playCount >= 3 ? 'cursor-not-allowed opacity-50' : ''}`}
                                                    >
                                                        {audioStates[audio?.questionId].isPlaying ?
                                                            <PauseCircleOutlined style={{ fontSize: '20px' }} /> :
                                                            <PlayCircleOutlined style={{ fontSize: '20px' }} />
                                                        }
                                                        <span className="ml-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                            {audioStates[audio?.questionId].playCount >= 2 ?
                                                                'Out of play' :
                                                                `Play/Stop (${2 - audioStates[audio?.questionId].playCount} times left)`
                                                            }
                                                        </span>
                                                    </button>
                                                )
                                            }
                                            <div className="mb-4">
                                                <p style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                    {questionsToRender[currentQuestionIndex]?.Question?.content}
                                                </p>
                                            </div>
                                            <div className="w-full overflow-x-auto">
                                                <div className="grid grid-cols-1 gap-1 min-w-[300px]">
                                                    {
                                                        questionsToRender[currentQuestionIndex]?.Question?.SubQuestions[0]?.Answers?.map((option, index) => (
                                                            <button
                                                                key={index}
                                                                onClick={() => isSubmitted ? null : handleAnswerSelect({
                                                                    id: option.id,
                                                                    questionId: questionsToRender[currentQuestionIndex]?.Question?.id
                                                                })}
                                                                className={`
                                                                    w-full grid grid-cols-12 items-center text-left border h-[70px]
                                                                    ${selectedAnswers[currentQuestionIndex]?.id === option.id
                                                                        ? "bg-[#fefac7]"
                                                                        : "bg-gray-100 text-gray-800 hover:bg-gray-200 border-gray-300"
                                                                    }
                                                                `}
                                                            >
                                                                <div className={`
                                                                    col-span-2 flex justify-center items-center border-r border-gray-300 bg-white h-full
                                                                    ${selectedAnswers[currentQuestionIndex]?.id === option.id
                                                                        ? "bg-[#fefac7]" : "bg-white"}
                                                                `}>
                                                                    <span className="font-bold text-lg p-2">{String.fromCharCode(65 + index)}</span>
                                                                </div>
                                                                <div className="col-span-10 ml-4 pr-4" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: FontWeights.medium }}>
                                                                    <span className="line-clamp-2">
                                                                        {option.content}
                                                                    </span>
                                                                </div>
                                                            </button>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                            {!isSubmitted && type === 'private' && (
                                                <button
                                                    onClick={() => handleShowKey(questionsToRender[currentQuestionIndex]?.Question?.id)}
                                                    className="mb-2 mt-4 border border-primary-500 text-primary-500 font-medium rounded-lg px-2 py-1 md:px-4 md:py-2 text-sm md:text-base"
                                                >
                                                    {showKeyQuestions[questionsToRender[currentQuestionIndex]?.Question?.id] ? 'Hide Key' : 'Show Key'}
                                                </button>
                                            )}
                                            {
                                                (isSubmitted || showKeyQuestions[questionsToRender[currentQuestionIndex]?.Question?.id]) && (
                                                    <div className="mt-4 w-full overflow-x-auto">
                                                        <div className="min-w-[300px]">
                                                            <span className="mr-2 block mb-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                Correct answer:
                                                            </span>
                                                            {
                                                                questionsToRender[currentQuestionIndex]?.Question?.SubQuestions?.map((subQuestion, index) => {
                                                                    const isCorrect = selectedAnswers[currentQuestionIndex]?.[questionsToRender[currentQuestionIndex]?.Question?.id]?.id ===
                                                                        subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.id;
                                                                    return (
                                                                        <div key={index} className={`${isCorrect ? 'text-green-600' : 'text-red-600'} break-words`}>
                                                                            {subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.content}
                                                                        </div>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    ) : questionsToRender[currentQuestionIndex]?.Question?.QuestionSkill?.TypeQuestion?.name === 'Listening14' ? (
                                        <div>
                                            <p className="mb-4" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                {questionsToRender[currentQuestionIndex]?.Question?.title}
                                            </p>
                                            {
                                                audioList?.map((audio, index) => (
                                                    audio?.questionId === questionsToRender[currentQuestionIndex]?.Question?.id) &&
                                                    <button
                                                        key={index}
                                                        onClick={() => handleToggle(audio?.questionId)}
                                                        disabled={audioStates[audio?.questionId].playCount >= 3}
                                                        className={`flex items-center ${audioStates[audio?.questionId].playCount >= 3 ? 'cursor-not-allowed opacity-50' : ''}`}
                                                    >
                                                        {audioStates[audio?.questionId].isPlaying ?
                                                            <PauseCircleOutlined style={{ fontSize: '20px' }} /> :
                                                            <PlayCircleOutlined style={{ fontSize: '20px' }} />
                                                        }
                                                        <span className="ml-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                            {audioStates[audio?.questionId].playCount >= 2 ?
                                                                'Out of play' :
                                                                `Play/Stop (${2 - audioStates[audio?.questionId].playCount} times left)`
                                                            }
                                                        </span>
                                                    </button>
                                                )
                                            }
                                            <div className="mb-4">
                                                <p style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                    {questionsToRender[currentQuestionIndex]?.Question?.content}
                                                </p>
                                            </div>
                                            <div className="w-full overflow-x-auto">
                                                <div className="min-w-[300px]">
                                                    {
                                                        questionsToRender[currentQuestionIndex]?.Question?.SubQuestions?.map((subQuestion, index) => (
                                                            <div className="flex flex-col md:flex-row mb-4 gap-2" key={index}>
                                                                <span className="md:min-w-[200px] md:w-auto" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                    {subQuestion.title}
                                                                </span>
                                                                <div className="flex-1">
                                                                    <select
                                                                        value={answers[subQuestion?.id] || ""}
                                                                        onChange={(e) => {
                                                                            handleAnswerChange(subQuestion.id, e.target.value)
                                                                            handleAnswerSelect(subQuestion.id)
                                                                        }}
                                                                        className="w-full md:w-auto border rounded px-2 py-1"
                                                                        disabled={isSubmitted}
                                                                    >
                                                                        <option value=""></option>
                                                                        {subQuestion?.Answers?.map((answer) => (
                                                                            <option key={answer.id} value={answer.id}>
                                                                                {answer.content}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                {
                                                                    isSubmitted && (
                                                                        <div className="mt-2 md:mt-0 md:ml-4">
                                                                            <span className="mr-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                                Correct answer:
                                                                            </span>
                                                                            <span className={`${answers[subQuestion.id] === subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.id?.toString()
                                                                                ? 'text-green-600'
                                                                                : 'text-red-600'
                                                                                } break-words`}>
                                                                                {subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.content}
                                                                            </span>
                                                                        </div>
                                                                    )
                                                                }
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                            {
                                                type === 'private' && <div className="mt-4">
                                                    <button
                                                        onClick={() => setShowTranscript(!showTranscript)}
                                                        className="mb-2 border border-primary-500 text-primary-500 font-medium rounded-lg px-4 py-2"
                                                    >
                                                        {showTranscript ? 'Hide Transcript' : 'Show Transcript'}
                                                    </button>
                                                    {showTranscript && (
                                                        <p
                                                            dangerouslySetInnerHTML={{
                                                                __html: questionsToRender[currentQuestionIndex]?.Question?.transcript?.replace(/\n/g, '<br />') || ''
                                                            }}
                                                            className="mb-4 break-words" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                        </p>
                                                    )}
                                                </div>
                                            }
                                        </div>
                                    ) : questionsToRender[currentQuestionIndex]?.Question?.QuestionSkill?.TypeQuestion?.name === 'Listening15' ? (
                                        <div>
                                            <p className="mb-4" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                {questionsToRender[currentQuestionIndex]?.Question?.title}
                                            </p>
                                            {
                                                audioList?.map((audio, index) => (
                                                    audio?.questionId === questionsToRender[currentQuestionIndex]?.Question?.id) &&
                                                    <button
                                                        key={index}
                                                        onClick={() => handleToggle(audio?.questionId)}
                                                        disabled={audioStates[audio?.questionId].playCount >= 3}
                                                        className={`flex items-center ${audioStates[audio?.questionId].playCount >= 3 ? 'cursor-not-allowed opacity-50' : ''}`}
                                                    >
                                                        {audioStates[audio?.questionId].isPlaying ?
                                                            <PauseCircleOutlined style={{ fontSize: '20px' }} /> :
                                                            <PlayCircleOutlined style={{ fontSize: '20px' }} />
                                                        }
                                                        <span className="ml-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                            {audioStates[audio?.questionId].playCount >= 2 ?
                                                                'Out of play' :
                                                                `Play/Stop (${2 - audioStates[audio?.questionId].playCount} times left)`
                                                            }
                                                        </span>
                                                    </button>
                                                )
                                            }
                                            <div className="mb-4">
                                                <p style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                    {questionsToRender[currentQuestionIndex]?.Question?.content}
                                                </p>
                                            </div>
                                            <div>
                                                {
                                                    questionsToRender[currentQuestionIndex]?.Question?.SubQuestions?.map((subQuestion, index) => (
                                                        <div className="flex flex-row mb-4" key={index}>
                                                            <span className="mr-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                {index + 1}. {subQuestion.title}
                                                            </span>
                                                            <select
                                                                value={answers[subQuestion?.id] || ""}
                                                                onChange={(e) => {
                                                                    handleAnswerChange(subQuestion.id, e.target.value)
                                                                    handleAnswerSelect(subQuestion.id)
                                                                }}
                                                                className="border rounded px-2 py-1 mx-1"
                                                                disabled={isSubmitted}
                                                            >
                                                                <option value=""></option>
                                                                {subQuestion?.Answers?.map((answer) => (
                                                                    <option key={answer.id} value={answer.id}>
                                                                        {answer.content}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {
                                                                isSubmitted && (
                                                                    <div>
                                                                        <span className="ml-4 mr-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                            Correct answer:
                                                                        </span>
                                                                        <span className={`${answers[subQuestion.id] === subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.id?.toString()
                                                                            ? 'text-green-600'
                                                                            : 'text-red-600'
                                                                            }`}>
                                                                            {subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.content}
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    ))
                                                }
                                                {
                                                    type === 'private' && <div className="">
                                                        <button
                                                            onClick={() => setShowTranscript(!showTranscript)}
                                                            className="mb-2 border border-primary-500 text-primary-500 font-medium rounded-lg px-4 py-2"
                                                        >
                                                            {showTranscript ? 'Hide Transcript' : 'Show Transcript'}
                                                        </button>
                                                        {showTranscript && (
                                                            <p
                                                                dangerouslySetInnerHTML={{
                                                                    __html: questionsToRender[currentQuestionIndex]?.Question?.transcript?.replace(/\n/g, '<br />') || ''
                                                                }}
                                                                className="mb-4" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                            </p>
                                                        )}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    ) : questionsToRender[currentQuestionIndex]?.Question?.QuestionSkill?.TypeQuestion?.name === 'Listening1617' ? (
                                        <div>
                                            <p className="mb-4" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                {questionsToRender[currentQuestionIndex]?.Question?.title}
                                            </p>
                                            {
                                                audioList?.map((audio, index) => (
                                                    audio?.questionId === questionsToRender[currentQuestionIndex]?.Question?.id) &&
                                                    <button
                                                        key={index}
                                                        onClick={() => handleToggle(audio?.questionId)}
                                                        disabled={audioStates[audio?.questionId].playCount >= 3}
                                                        className={`flex items-center ${audioStates[audio?.questionId].playCount >= 3 ? 'cursor-not-allowed opacity-50' : ''}`}
                                                    >
                                                        {audioStates[audio?.questionId].isPlaying ?
                                                            <PauseCircleOutlined style={{ fontSize: '20px' }} /> :
                                                            <PlayCircleOutlined style={{ fontSize: '20px' }} />
                                                        }
                                                        <span className="ml-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                            {audioStates[audio?.questionId].playCount >= 2 ?
                                                                'Out of play' :
                                                                `Play/Stop (${2 - audioStates[audio?.questionId].playCount} times left)`
                                                            }
                                                        </span>
                                                    </button>
                                                )
                                            }
                                            <div className="mb-4">
                                                <p style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                    {questionsToRender[currentQuestionIndex]?.Question?.content}
                                                </p>
                                            </div>
                                            <div>
                                                {
                                                    questionsToRender[currentQuestionIndex]?.Question?.SubQuestions?.map((subQuestion, index) => (
                                                        <div className="mb-10" key={index}>
                                                            <p className="mb-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                {subQuestion.title}
                                                            </p>
                                                            {
                                                                subQuestion?.Answers?.map((option, answerIndex) => (
                                                                    <button
                                                                        key={answerIndex}
                                                                        onClick={() => handleAnswerSelect({ ...option, SubQuestionId: subQuestion.id })}
                                                                        disabled={isSubmitted}
                                                                        className={`
                                                                    w-full grid grid-cols-12 items-center text-left border h-[70px]
                                                                    ${selectedAnswers[currentQuestionIndex]?.[subQuestion.id]?.id === option.id
                                                                                ? "bg-[#fefac7]"
                                                                                : "bg-gray-100 text-gray-800 hover:bg-gray-200 border-gray-300"
                                                                            }
                                                                `}
                                                                    >
                                                                        <div className={`
                                                                    col-span-2 flex justify-center items-center border-r border-gray-300 bg-white h-full
                                                                    ${selectedAnswers[currentQuestionIndex]?.[subQuestion.id]?.id === option.id
                                                                                ? "bg-[#fefac7]" : "bg-white"}
                                                                `}>
                                                                            <span className="font-bold text-lg p-2">{String.fromCharCode(65 + answerIndex)}</span>
                                                                        </div>
                                                                        <div className="col-span-10 ml-4" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: FontWeights.medium }}>
                                                                            <span>
                                                                                {option.content}
                                                                            </span>
                                                                        </div>
                                                                    </button>
                                                                ))
                                                            }
                                                            {
                                                                (isSubmitted || showKeyQuestions[questionsToRender[currentQuestionIndex]?.Question?.id]) && (
                                                                    <div className="mt-4">
                                                                        <span className="ml-4 mr-2" style={{ fontSize: `${Fontsizes.sm}`, fontWeight: `${FontWeights.normal}` }}>
                                                                            Correct answer:
                                                                        </span>
                                                                        <span className={`${selectedAnswers[currentQuestionIndex]?.[subQuestion.id]?.id ===
                                                                            subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.id
                                                                            ? 'text-green-600'
                                                                            : 'text-red-600'
                                                                            }`}>
                                                                            {subQuestion?.Answers?.find(answer => answer?.isCorrect === '1')?.content}
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }
                                                        </div>
                                                    ))
                                                }
                                                {
                                                    !isSubmitted && type === 'private' && <button
                                                        onClick={() => handleShowKey(questionsToRender[currentQuestionIndex]?.Question?.id)}
                                                        className="border border-primary-500 text-primary-500 font-medium rounded-lg px-4 py-2"
                                                    >
                                                        {showKeyQuestions[questionsToRender[currentQuestionIndex]?.Question?.id] ? 'Hide Key' : 'Show Key'}
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )
                                }
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Navigation - Made responsive */}
            <div className="fixed bottom-0 left-0 right-0 bg-white border-t flex justify-between items-center px-2 md:px-4 py-2">
                <div className="flex space-x-2 md:space-x-4">
                    <Button
                        icon={<UnorderedListOutlined />}
                        shape="default"
                        size={window.innerWidth < 768 ? "middle" : "large"}
                        onClick={toggleModal}
                        disabled={!isExamStarted && !isSubmitted}
                    />
                    {/* {renderTranslationButton()} */}
                </div>

                <div className="flex space-x-1 md:space-x-2">
                    <Button
                        type="default"
                        size={window.innerWidth < 768 ? "middle" : "large"}
                        onClick={handlePrevious}
                        disabled={(isInstructions && currentQuestionIndex === 0)}
                    >
                        Previous
                    </Button>

                    {currentQuestionIndex === questionsToRender?.length - 1 && isExamStarted ? (
                        <Button
                            type="primary"
                            size={window.innerWidth < 768 ? "middle" : "large"}
                            style={{ backgroundColor: Colors.primary }}
                            onClick={handleSubmitExam}
                            disabled={isSubmitted}
                        >
                            Submit Exam
                        </Button>
                    ) : (
                        <Button
                            type="primary"
                            size={window.innerWidth < 768 ? "middle" : "large"}
                            style={{ backgroundColor: Colors.primary }}
                            onClick={handleNext}
                            disabled={isInstructions ? false : currentQuestionIndex === questionsToRender?.length - 1}
                        >
                            {isInstructions && !isSubmitted ? "Start" : "Next"}
                        </Button>
                    )}
                    {isSubmitted && (
                        <Button
                            type="primary"
                            size={window.innerWidth < 768 ? "middle" : "large"}
                            style={{ backgroundColor: Colors.primary }}
                            onClick={handleRetakeExam}
                        >
                            Retake Exam
                        </Button>
                    )}
                </div>
            </div>

            {/* Question List Modal - Made responsive */}
            <Modal
                title={<span className="modal-title">Question List</span>}
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
                width={window.innerWidth < 768 ? "90%" : 400}
                style={{
                    position: "fixed",
                    top: "20px",
                    left: window.innerWidth < 768 ? "5%" : "20px",
                    height: "calc(100vh - 170px)",
                    borderRadius: "8px",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    zIndex: 1050,
                }}
                styles={{
                    body: {
                        height: "calc(100vh - 170px)",
                        overflow: "auto",
                        pointerEvents: "auto",
                    }
                }}
                wrapClassName="custom-modal-wrap"
            >
                <div className="flex flex-col space-y-4">
                    <div className="space-y-2">
                        <div className={`border rounded-lg p-3 mt-4 ${isInstructions ? "bg-gray-200" : ""}`}>
                            <p className="cursor-pointer" onClick={() => setIsInstructions(true)}>
                                {skill?.name === "Listening" ? "Aptis General Listening Instructions" : "Aptis General Reading Instructions"}
                            </p>
                        </div>
                        <div className="border rounded-lg p-3">
                            <span className="mb-1">Questions: </span>
                            <span className="ext-gray-500">
                                {questionsToRender?.length} Questions
                            </span>
                            <div className="mt-2">
                                {questionsToRender?.map((question, i) => (
                                    <div
                                        key={question.id}
                                        className={`p-2 border ${i === currentQuestionIndex && !isInstructions ? "bg-gray-200" : ""} 
                                                rounded-md mb-2 flex justify-between cursor-pointer hover:bg-gray-100`}
                                        onClick={() => handleQuestionSelect(i)}
                                    >
                                        <span className="text-gray-700">{i + 1}</span>
                                        <span className="text-gray-500">
                                            {answeredQuestions[i] ? "Answered" : "Not Answered"}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* Score Display - Made responsive */}
            {isSubmitted && (
                <div className="fixed top-4 right-4 md:right-8 lg:right-12 bg-white p-3 md:p-4 shadow-md border">
                    <p className="text-lg md:text-xl lg:text-2xl font-bold text-red-600">
                        Total: {totalScore} / 50
                    </p>
                </div>
            )}
        </div>
    );
};

export default Exam;